module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/lwtDnS/tc-custom/9781446378311.jpg?1704315410092",
      "alt": "This image is the cover for the book Quilts from Tilda's Studio, Tilda"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Quilts from Tilda's Studio, Tilda\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The beloved Scandinavian Tilda brand brings you quilts for all seasons—from springtime’s Scrapflower Quilt to winter’s Happy Snowman Quilt.")]), _c('br'), _c('br'), _vm._v("World-renowned for her beautiful fabrics and charming designs, Tone Finnanger has established Tilda as a creative lifestyle that makers dream of. From her inspirational studio on an island in Norway’s Oslofjord, comes this divine collection of quilt patterns, all made with the latest Tilda fabric collections."), _c('br'), _c('br'), _vm._v("Fourteen quilts, many with matching pillows, are shown with gorgeous photography, in-depth instructions, piecing diagrams and full-size templates. The designs feature a range of motifs including cats, angels, birdhouses, trees, teapots, fruit, flowers and more that quilters will simply adore. "), _c('br'), _c('br'), _vm._v("Cut, piece, baste, quilt and bind your way into Tilda’s world with this exquisite pattern book, and make quilts you’ll cherish forever.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Tone Finnanger\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Tone Finnanger is the founder and designer of the much-loved Tilda brand, which she started in 1999 at the age of 25. She lives on an island in the Oslo fjord. Norway. She is the author of over 20 books which have been translated into more than 12 languages.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    A David And Charles Book\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0